/* @ngInject */
function AssetPreviewHeaderController (
  $scope,
  $rootScope,
  $state,
  $translate,
  $q,
  $location,
  $timeout,
  AssetPreviewService,
  NewAssetService,
  ModalService,
  Utils,
  CONSTANTS,
  ArtsService,
  ArtCollectionsService,
  SegmentService,
  MessageService,
  ToastService,
  TemplateService,
  UdsModalService,
  AssetService,
  TasksService,
  UploadService,
  RepositoryService,
  CampaignService,
  ConfirmationModalService,
  WideService,
  ShareLinkService
) {
  const getUnarchiveTemplateDialogController = () =>
    $q.when(import('../../../arts/dialogs/unarchive-template/unarchive-template-dialog.controller'))
  const getUnarchiveArtWarningDialogController = () =>
    $q.when(import('../../../arts/dialogs/unarchive-art-warning/unarchive-art-warning-dialog.controller'))
  const getMoveTemplateCollectionController = () =>
    $q.when(import('../../../arts/dialogs/move-template-collection/move-template-collection-dialog.controller'))
  const getShareArtDialogController = () =>
    $q.when(import('../../../arts/dialogs/share-art/share-art-dialog.controller'))
  const getDownloadDialogController = () => $q.when(import('../../../arts/dialogs/download/download-dialog.controller'))
  const getMergeArtsDialogController = () =>
    $q.when(import('../../../arts/dialogs/merge-arts/merge-arts-dialog.controller'))
  const getTemplateSuggestionsDialogController = () =>
    $q.when(import('../../../arts/dialogs/template-suggestions/template-suggestions-dialog.controller'))
  const getUseTermsListDialogController = () =>
    $q.when(import('../../../arts/dialogs/use-terms/list/use-terms-list-dialog.controller'))
  const getTemplatePropertiesDialogController = () =>
    $q.when(import('../../../arts/dialogs/template-properties/template-properties-dialog.controller'))
  const getManageAssetsDialogController = () => $q.when(import('../../../repository/dialogs/manage-assets/manage-assets-dialog.controller'))
  const getUnavailableTemplateDialogController = () => $q.when(import('../../../arts/dialogs/unavailable-template/unavailable-template-dialog.controller'))
  const getOrganizeAssetDialogController = () => $q.when(import('../../../repository/dialogs/organize-asset/organize-asset-dialog.controller'))
  const getMoveToTrashDialogController = () => $q.when(import('../../../repository/dialogs/move-to-trash/move-to-trash-dialog.controller'))
  const getRemoveAttachmentDialogController = () =>
    $q.when(import('../../../campaigns/dialogs/remove-attachment/remove-attachment-dialog.controller'))
  const getShareWithGuestsDialogController = () =>
    $q.when(import('../../../core/dialogs/share-with-guests/share-with-guests-dialog.controller'))
  const getSendToWideDialogController = () =>
    $q.when(import('../../../arts/dialogs/send-to-wide/send-to-wide-dialog.controller'))

  const defaultNameDisplayLength = 12

  $scope.flags = {
    uploadingNewVersion: false,
    loadingCustomizeBtn: false,
    isWorkflow: false,
    isMultilocal: false
  }
  $scope.buttons = []
  $scope.location = $scope.location || 'materials'

  const api = {
    getShareWithGuestsDialogController,
    getOrganizeAssetDialogController,
    getMoveToTrashDialogController,
    getUnavailableTemplateDialogController,
    getTemplatePropertiesDialogController,
    getUnarchiveTemplateDialogController,
    getUnarchiveArtWarningDialogController,
    getMoveTemplateCollectionController,
    getShareArtDialogController,
    getDownloadDialogController,
    getMergeArtsDialogController,
    getTemplateSuggestionsDialogController,
    getUseTermsListDialogController,
    getSendToWideDialogController,
    _stateGoTo,
    _openRepositoryAssetSettings,
    _handleShareAsset,
    _isOutdated,
    _handleAssetDownload,
    _openEditor,
    _openUnarchiveTemplateDialog,
    _openUnarchiveArtWarningDialog,
    _archiveArt,
    _unarchiveArt,
    _showUnavailableDialog,
    _moveTo,
    _openMergeArtsDialog,
    _openUseTermsListDialog,
    _sendSegmentDownloadEvents,
    _openTemplateSuggestionsDialog,
    _openDownloadDialog,
    _sendArtToDesigning,
    _updateCurrentTemplate,
    _defineButtons,
    _defineButtonsUser,
    _showDuplicateButton,
    _showShareButton,
    _deleteBrandAsset,
    _copyTemplateLink,
    _moveAssetTo,
    _clickDownloadAsset,
    _clickShareAsset,
    _clickOpenFileLocation,
    _archiveUnarchiveAsset,
    _deleteChecklistAsset,
    _clickEditAsset,
    _turnPublicRequestAttachmentAsset,
    _deleteRequestAttachmentAsset,
    _openBindCampaignDialog,
    _unbindAssetFromCampaign,
    _isBluefitDesigner,
    _removeAttachmentFromCampaign,
    _openRemoveAttachmentDialog
  }
  this.getApi = () => api

  $scope.$watchCollection('template', () => {
    $scope.buttons = api._defineButtons()
    $scope.buttonsUser = api._defineButtonsUser()
  })

  $scope.companyFeatures = {
    campaigns: {
      access: false
    }
  }

  activate()

  function activate () {
    if ($scope.publicCampaign) return
    $scope.flags.isWorkflow = $rootScope.companyWithBillingPackage.billingPackage.plan.pricingPackage.id === 4
    $scope.flags.isMultilocal = !$scope.flags.isWorkflow
    $scope.isTemplate = !$scope.template.assetId || $scope.template.assetId !== $scope.template.id

    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      $scope.companyFeatures.campaigns = {
        access: !!features['CAMPAIGNS.ACCESS']
      }
    })
  }

  const deregisterAssetPreviewClose = $rootScope.$on('asset-preview.close', () => {
    $scope.closePreview()
  })

  const deregisterUpdateTemplateName = $rootScope.$on('preview-header.update-template-name', (_, newValue) => {
    $scope.template.name = newValue
  })

  $scope.$on('$destroy', function () {
    deregisterAssetPreviewClose()
    deregisterUpdateTemplateName()
  })

  $scope.closePreview = () => {
    AssetPreviewService.closePreview()
  }

  function _stateGoTo (toState, params) {
    $state.go(toState, params).then(() => {
      AssetPreviewService.closePreview()

      if ($scope.fromCampaignAction) {
        $rootScope.$broadcast('campaign.close-action-materials-dialog')
      }
    })
  }

  function _isOutdated (template, actionFunction, actionType) {
    const temporarilyAvailable = template.temporarilyAvailable?.length ? template.temporarilyAvailable[0] : null
    const isDownload = actionType === 'download'
    const isShare = actionType === 'share'
    const isDuplicate = actionType === 'duplicate'

    if (template.isTemplate === true || $rootScope.isUserSysAdminAdminDesigner()) {
      actionFunction(template)
      return
    }

    if (template.templateHasUpdate) {
      api._showOutdatedDialog(template)
    } else if (template.unavailable && template.approvalStatus === 'PENDING_REWORK' && actionType === 'editor') {
      actionFunction(template)
    } else if (temporarilyAvailable && (isDownload || isShare || isDuplicate)) {
      if (isDownload && !temporarilyAvailable.downloaded) {
        actionFunction(template)
      } else if (isShare && !temporarilyAvailable.shared) {
        actionFunction(template)
      } else {
        api._showUnavailableDialog(template)
      }
    } else if (template.unavailable) {
      api._showUnavailableDialog(template)
    } else {
      actionFunction(template)
    }
  }

  function _showUnavailableDialog (art) {
    api
      .getUnavailableTemplateDialogController()
      .then(({ UnavailableTemplateDialogController }) => {
        return ModalService.showModal({
          templateId: 'unavailableTemplate.html',
          templateUrl: '/arts/dialogs/unavailable-template/unavailable-template-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: UnavailableTemplateDialogController
        })
      })
      .then(shouldArchive => {
        if (shouldArchive) {
          api._archiveArt(art)
        }
      })
  }

  function _clickShareAsset () {
    $scope.shareAsset()
  }

  $scope.shareAsset = () => {
    api._isOutdated($scope.template, api._handleShareAsset, 'share')
  }

  function _copyTemplateLink () {
    ArtsService.copyArtUrlToClipboard($scope.template.id)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('copyPostLink.toast.success'))
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('copyPostLink.toast.error'))
      })
  }

  function _handleShareAsset (template) {
    api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
      template.location = $scope.location
      template.contextData = $scope.contextData
      const shareArtDialog = UdsModalService.createModal({
        controller: ShareArtDialogController,
        modalName: 'shareArtDialog',
        data: {
          art: template
        },
        onClose: shared => {
          if (shared && template.temporarilyAvailable[0]) {
            ArtsService.updateTemporarilyAvailableArt(template.id, { shared: true })
          }
        }
      })

      shareArtDialog.open()
    })
  }

  function _clickDownloadAsset () {
    $scope.downloadAsset()
  }

  function _clickEditAsset () {
    $scope.customizeAsset()
  }

  $scope.downloadAsset = () => {
    if (!$scope.isTemplate) {
      const downloadModule = AssetPreviewService.getModuleForLocation($scope.location)

      if ($scope.publicCampaign) {
        ShareLinkService.getDownloadArtPublicFolder($scope.template.id, $scope.linkUuid, downloadModule)
      } else {
        AssetService.downloadAsset($scope.template.assetId, downloadModule)
      }

      $rootScope.$broadcast('downloadedAssetPreviewHeader', $scope.template.assetId)
      ToastService.showSuccessToast($translate.instant('successDownloadFile'))
      return
    }

    api._isOutdated($scope.template, api._handleAssetDownload, 'download')
  }

  function _handleAssetDownload (template) {
    if (template.needApproval && template.approvalStatus !== 'APPROVED' && ($rootScope.isUser() || $rootScope.isGuest())) {
      ToastService.showErrorToast($translate.instant('pendingApprovalErrorMsg'))
      return
    }
    if (template.linkedTemplates && template.linkedTemplates.length > 0) {
      api._openMergeArtsDialog(template)
    } else if (template.isTemplate && !template.isCustomizable) {
      $scope.downloading = true

      if (template.useTermsId && !$scope.agreeUseTerms) {
        ModalService.close()
        api._openUseTermsListDialog(template)
        return
      }

      api._sendSegmentDownloadEvents(template)

      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [template.id])

      if ($scope.location) {
        const downloadModule = AssetPreviewService.getModuleForLocation($scope.location)
        url = Utils.fnAddQueryToUrl(url, { downloadModule })
      }

      const file = Utils.downloadFile(url, { artId: template.id })
      $scope.downloading = false
      if (template.suggestions) {
        api._openTemplateSuggestionsDialog(template)
      }

      ToastService.showSuccessToast($translate.instant('successDownloadFile'))
      return file
    } else {
      api._openDownloadDialog(template)
    }
  }

  function _openMergeArtsDialog (template) {
    api.getMergeArtsDialogController().then(({ MergeArtsDialogController }) => {
      ModalService.showModal({
        templateId: 'mergeArtsDialog.html',
        templateUrl: '/arts/dialogs/merge-arts/merge-arts-dialog.html?$$REVISION$$',
        destroyable: true,
        controller: MergeArtsDialogController,
        data: {
          template: template,
          linkedTemplates: template.linkedTemplates.slice()
        }
      })
    })
  }

  function _openUseTermsListDialog (template) {
    api.getUseTermsListDialogController().then(({ UseTermsListDialogController }) => {
      ModalService.showModal({
        templateId: 'useTermsListDialog.html',
        templateUrl: '/arts/dialogs/use-terms/list/use-terms-list-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: UseTermsListDialogController,
        data: {
          useTermId: template.useTermsId,
          artId: template.id,
          useType: 'DOWNLOAD'
        }
      }).then(agreeTerms => {
        if (agreeTerms) {
          $scope.agreeUseTerms = true
          $scope.downloadTemplateClick(template)
        }
      })
    })
  }

  function _sendSegmentDownloadEvents (template) {
    $q.all([ArtsService.getArtDetailById(template.id), ArtsService.getInfosBusinessData(template.id)]).then(
      ([art, businessDataInfo]) => {
        const place = $state.current.name
        const productValue = !!document.querySelector('#canvas_group [data-product]')
        SegmentService.track('downloaded-art', {
          art_id: template.id,
          photoframes: 0,
          permission: 'download',
          type: 'only_download',
          template_id: art.baseTemplateId,
          place,
          element_hyperlink: art.hyperlinks,
          format_type: template?.productType?.toLowerCase?.(),
          business_data: businessDataInfo.hasPlaceholdersSaved,
          video: art.hasVideo,
          product: productValue
        })
      }
    )
  }

  function _openTemplateSuggestionsDialog (template) {
    api.getTemplateSuggestionsDialogController().then(({ TemplateSuggestionsDialogController }) => {
      ModalService.showModal({
        templateId: 'templateSuggestions.html',
        templateUrl: '/arts/dialogs/template-suggestions/template-suggestions-dialog.html?$$REVISION$$',
        controller: TemplateSuggestionsDialogController,
        destroyable: true,
        data: {
          _sSuggestions: template.suggestions,
          _bIsPrintInstruction: template.product && template.product.type === 'PRINTABLE'
        }
      })
    })
  }

  function _openDownloadDialog (template) {
    api.getDownloadDialogController().then(({ DownloadDialogController }) => {
      const downloadDialog = UdsModalService.createModal({
        controller: DownloadDialogController,
        modalName: 'downloadDialog',
        data: {
          _iArtId: template.id,
          _customizationLevel: template.customizationLevel,
          _isCustomizable: template.isCustomizable,
          _sDownloadOption: template.downloadOption,
          _iProductId: template.productId,
          _oTemplate: Object.assign({}, template, {
            details: {
              instructions: template.instructions,
              suggestions: template.suggestions
            }
          })
        }
      })

      downloadDialog.open()
    })
  }

  function _isBluefitDesigner () {
    return +$rootScope.oUser.customerCompanyId === 604 && $rootScope.isUserDesigner()
  }

  $scope.handleEditAction = function (action) {
    const isUnavailable = !!$scope.template.unavailable
    const isUserAndArtApproved = $scope.template.approvalStatus === 'APPROVED' && $rootScope.isUser() && !isUnavailable
    if (api._isBluefitDesigner() || isUserAndArtApproved) {
      $scope.flags.loadingCustomizeBtn = true
      $scope.duplicateArt()
      return
    }
    action()
  }

  $scope.getEditTextToTranslate = (template) => {
    if (api._isBluefitDesigner()) return $translate.instant('toCustomize')
    return $translate.instant(template.isTemplate ? 'editTemplate' : 'edit')
  }

  $scope.customizeAsset = () => {
    api._isOutdated($scope.template, api._openEditor.bind(null, $scope.template, true), 'duplicate')
  }

  $scope.editAsset = () => {
    api._isOutdated($scope.template, $scope.goToCustomize)
  }

  $scope.publishAsTemplate = (template, showConvertTemplateDialog) => {
    api._isOutdated(template, showConvertTemplateDialog)
  }

  $scope.showConvertTemplateDialog = function (art) {
    api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
      const templatePropertiesDialog = UdsModalService.createModal({
        controller: TemplatePropertiesDialogController,
        modalName: 'templatePropertiesDialog',
        data: {
          art: art,
          shouldConvertToTemplate: true,
          isCustomizable: art.isCustomizable,
          artCollectionId: art.artCollectionId
        },
        onClose: info => {
          if (info && info.wasPublished) {
            if (info.artCollectionId) {
              ArtCollectionsService.find(info.artCollectionId).then(res => {
                if (!res.parentId && !res.highlighted) {
                  $state.go('arts.templates', {}, { reload: true })
                } else {
                  $state.go('arts.collection', { id: info.artCollectionId })
                }
              })
            } else {
              $state.go('arts.companyTemplates')
            }
          }
        }
      })

      templatePropertiesDialog.open()
    })
  }

  function _openEditor (template, showApprovalButtons) {
    if (template.isTemplate) {
      api._stateGoTo('customizeTemplate', {
        from: $state.current.name,
        fromParams: $state.params,
        templateId: $scope.template.id
      })
    } else {
      if (template.needApproval && template.approvalStatus === 'APPROVED' && $rootScope.isUser()) {
        MessageService.warning({
          title: $translate.instant('warning'),
          text: $translate.instant('editApprovedArtMsg'),
          confirmButton: $translate.instant('edit'),
          cancelButton: $translate.instant('cancel'),
          press: api._sendArtToDesigning(template),
          allowOutsideClick: false,
          closeOnConfirm: false,
          showLoaderOnConfirm: true
        })
        return
      }

      $timeout(
        () => {
          const params = {
            idArt: template.id,
            from: $state.current.name,
            fromParams: $state.params
          }

          if (showApprovalButtons) {
            params.showApprovalButtons = true
          }

          api._stateGoTo('customizeArt', params)
        },
        100,
        true
      )
    }
  }

  $scope.goToCustomize = function (template) {
    api._stateGoTo('customizeArt', {
      idArt: template.id,
      hideConvertTemplateButton: true,
      from: $state.current.name,
      fromParams: $state.params
    })
  }

  function _sendArtToDesigning (art) {
    ArtsService.sendArtToDesiging(art.id).then(function () {
      api._stateGoTo('customizeArt', {
        idArt: art.id,
        from: $state.current.name,
        fromParams: $state.params
      })
    })
  }

  function _clickOpenFileLocation () {
    $scope.openFileLocation()
  }

  $scope.openFileLocation = function () {
    api._stateGoTo('arts.collection', { id: $scope.template.artCollectionId })
  }

  $scope.duplicateArt = function () {
    if ($scope.template.isTemplate) {
      return api._stateGoTo('customizeTemplate', {
        from: $state.current.name,
        fromParams: $state.params,
        templateId: $scope.template.id
      })
    }

    ArtsService.cloneArt($scope.template.id)
      .then(response => {
        $scope.flags.loadingCustomizeBtn = false
        api._openEditor(response)
      })
      .catch(ToastService.defaultErrorToast)
  }

  $scope.showDownloadButton = function (template) {
    const section = $scope.contextData.section
    const sectionAllowsDownload = template.asset?.allowUserDownload || section?.allowUserDownload
    const downloadAllowed = section ? sectionAllowsDownload : true

    if (section) {
      return downloadAllowed
    }

    const isApproved = template.approvalStatus === 'APPROVED'

    if (!$scope.template.isCustomizable || $scope.template.customizationLevel === 'ONLY_DOWNLOAD') {
      return true
    }

    return (
      ((!template.needApproval && $rootScope.isUser() && !template.isTemplate) ||
        ($rootScope.oUserCompanyConfigurations.ENABLE_DOWNLOAD_APPROVED_ART && isApproved && !template.isTemplate)) &&
      !template.isArchived &&
      !template.unavailable
    )
  }

  function _showDuplicateButton (template) {
    if ($scope.template.isArchived) {
      return false
    }

    if (!$rootScope.isUserSysAdminAdminDesigner() && $scope.location !== 'materialsCustomizations') {
      return false
    }

    return template.isCustomizable && template.approvalStatus !== 'REJECTED'
  }

  function _showShareButton () {
    if (
      !$scope.template.isCustomizable ||
      $scope.template.customizationLevel === 'ONLY_DOWNLOAD' ||
      $scope.template.isTemplate
    ) {
      return false
    }

    const isApprovedArt = $scope.template.approvalStatus === 'APPROVED' && $scope.template.needApproval
    const isAvailable = !$scope.template.unavailable
    const isApprovedValidation = isApprovedArt || !$scope.template.needApproval
    const isArchived = $scope.template.isArchived

    return isAvailable && !isArchived && isApprovedValidation
  }

  function _defineButtons () {
    const asset = $scope.template

    const buttonsToShow = {
      materials: [
        {
          text: $translate.instant('duplicate'),
          icon: 'copy',
          click: $scope.duplicateArt,
          show: api._showDuplicateButton($scope.template),
          divider: false
        },
        {
          text: $translate.instant('copyPostLink.buttonText'),
          icon: 'link',
          click: api._copyTemplateLink,
          show: true,
          divider: false
        },
        {
          text: $translate.instant('moveTo'),
          icon: 'dam',
          click: api._moveAssetTo,
          show: true,
          divider: false
        },
        {
          text: $translate.instant('download'),
          icon: 'download',
          click: api._clickDownloadAsset,
          show: true,
          divider: false
        },
        {
          text: $translate.instant('openFileLocation'),
          icon: 'dam',
          click: api._clickOpenFileLocation,
          show: true,
          divider: false
        },
        {
          text: $scope.template.isArchived ? $translate.instant('unarchive') : $translate.instant('archive'),
          icon: 'archive',
          click: api._archiveUnarchiveAsset,
          show: true,
          divider: false
        }
      ],
      materialsCustomizations: [
        {
          text: $translate.instant('moveTo'),
          icon: 'dam',
          click: api._moveAssetTo,
          show: true,
          divider: false
        },
        {
          text: $translate.instant('duplicate'),
          icon: 'copy',
          click: $scope.duplicateArt,
          show: api._showDuplicateButton($scope.template),
          divider: false
        },
        {
          text: $translate.instant('download'),
          icon: 'download',
          click: api._clickDownloadAsset,
          show: true,
          divider: false
        },
        {
          text: $scope.template.isArchived ? $translate.instant('unarchive') : $translate.instant('archive'),
          icon: 'archive',
          click: api._archiveUnarchiveAsset,
          show: true,
          divider: false
        }
      ],
      brand: [
        {
          text: $translate.instant('delete'),
          icon: 'trash',
          click: api._deleteBrandAsset,
          show: true,
          divider: false
        }
      ],
      checklist: [
        {
          text: $translate.instant('delete'),
          icon: 'trash',
          click: api._deleteChecklistAsset,
          show: true,
          divider: false
        }
      ],
      materialsApproval: [
        {
          text: $translate.instant('editMaterial'),
          icon: 'edit',
          click: api._clickEditAsset,
          show: true,
          divider: false
        },
        {
          text: $translate.instant('download'),
          icon: 'download',
          click: api._clickDownloadAsset,
          show: true,
          divider: false
        }
      ],
      workflow: [
        {
          text: $translate.instant(asset?.isPrivate ? 'unlockAsset' : 'lockAsset'),
          icon: asset?.isPrivate ? 'unlock' : 'lock',
          click: api._turnPublicRequestAttachmentAsset,
          show: $rootScope.isUserSysAdminAdminDesigner() && $scope.contextData.task?.author?.role === 'USER',
          divider: false
        },
        {
          text: $translate.instant('delete'),
          icon: 'trash',
          click: api._deleteRequestAttachmentAsset,
          show: true,
          divider: false
        }
      ],
      repository: [
        {
          text: $translate.instant('download'),
          icon: 'download',
          click: $scope.downloadAsset,
          show: true,
          divider: true
        },
        {
          text: $translate.instant('configurations'),
          icon: 'settings',
          click: api._openRepositoryAssetSettings,
          show: true,
          divider: true
        },
        {
          text: $translate.instant('organize'),
          icon: 'dam',
          show: false,
          divider: true
        },
        {
          text: $translate.instant('archive'),
          icon: 'archive',
          click: () => {
            if (!$scope.onDeleteAsset) {
              return
            }

            $scope.onDeleteAsset($scope.template)
          },
          show: !$scope.template.isArchived,
          divider: false
        },
        {
          text: $translate.instant('restore'),
          icon: 'refresh',
          click: () => {
            if (!$scope.onRestoreAsset) {
              return
            }

            $scope.onRestoreAsset($scope.template)
          },
          show: $scope.template.isArchived,
          divider: false
        }
      ],
      repositoryFolder: [
        {
          text: $translate.instant('download'),
          icon: 'download',
          click: $scope.downloadFolderAssets,
          show: true,
          divider: true
        },
        {
          text: $translate.instant('settings'),
          icon: 'settings',
          click: $scope.openFolderSettings,
          show: true,
          divider: false
        },
        {
          text: $translate.instant('organize'),
          icon: 'dam',
          click: $scope.organizeFolder,
          show: true,
          divider: true
        },
        {
          text: $translate.instant('archive'),
          icon: 'archive',
          click: $scope.moveFolderToTrash,
          show: true,
          divider: false
        }
      ]
    }

    const hasCampaignAccess = $scope.companyFeatures.campaigns.access
    if (hasCampaignAccess) {
      buttonsToShow.materials.push({
        text: $translate.instant('campaignsModule.dialogs.bindCampaign.headerTitleUnbind'),
        icon: 'target',
        click: api._openBindCampaignDialog,
        show: $scope.template.campaignId && $scope.template.isActiveInCampaign !== false,
        divider: false
      })

      buttonsToShow.campaign = [
        {
          text: $translate.instant('campaignsModule.dialogs.bindCampaign.headerTitleUnbind'),
          icon: 'target',
          click: api._openBindCampaignDialog,
          show: true,
          divider: false
        }
      ]

      buttonsToShow.campaignAttachment = [
        {
          text: $translate.instant('delete'),
          icon: 'trash',
          click: api._openRemoveAttachmentDialog,
          show: true,
          divider: false
        }
      ]
    }

    if (buttonsToShow[$scope.location]) return buttonsToShow[$scope.location]

    return buttonsToShow.materials
  }

  function _deleteBrandAsset () {
    const sectionId = $scope.contextData.section.id
    const assetId = $scope.template.assetId

    $scope.onDeleteAsset(sectionId, assetId)
  }

  $scope.downloadFolderAssets = () => {
    const folderId = $scope.template.id

    if (folderId) {
      RepositoryService.downloadAssetsFolderBatch([folderId], 'REPOSITORY')
        .then(() => {
          ToastService.showSuccessToast($translate.instant('assetFolder.toasts.downloadAssets.success'))
        })
        .catch(() => {
          ToastService.showErrorToast($translate.instant('assetFolder.toasts.downloadAssets.error'))
        })
    }
  }

  $scope.openFolderSettings = () => {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          folders: [$scope.template],
          tabToOpen: 'general'
        },
        onClose: (updatedFolder) => {
          if (!updatedFolder) {
            return
          }

          $scope.template.title = Utils.truncateText(updatedFolder.name, defaultNameDisplayLength)
          $rootScope.$emit('asset-folder.update-folder-name', updatedFolder.id, updatedFolder.name)
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.organizeFolder = () => {
    const folder = $scope.template
    const nameDisplayLength = 32
    const folders = [{
      id: folder.id,
      assetName: Utils.truncateText(folder.title, nameDisplayLength),
      parentId: folder.parentId,
      isFolder: true
    }]

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets: folders,
          isRestoring: false,
          hasOrganizedFeature: true
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            $rootScope.$emit('repository.organized.reload-folders', folder.id)
            $scope.closePreview()
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  $scope.moveFolderToTrash = () => {
    const folder = $scope.template

    const assets = [{
      id: folder.id,
      assetName: folder.title,
      assetIcon: 'dam',
      isFolder: true
    }]

    getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            $rootScope.$emit('repository.organized.reload-folders', folder.id)
            $scope.closePreview()
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  $scope.copyFolderLink = () => {
    const folders = [$scope.template]

    RepositoryService.copyAssetsFolderUrlsToClipboard(folders)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('assetFolder.toasts.copyLinkBatch.success', { folderName: $scope.template.title }))
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('assetFolder.toasts.copyLinkBatch.error', { folderName: $scope.template.title }))
      })
  }

  $scope.showSendToWideButton = () => {
    const belongsToWideFormat = WideService.shouldShowSendToWideButton($scope.template)
    const isApproved = $scope.template.approvalStatus === 'APPROVED'
    const isNotCustomizable = !$scope.template.isCustomizable
    const isOnlyDownload = $scope.template.customizationLevel === 'ONLY_DOWNLOAD'
    const isTemplate = $scope.isTemplate
    const materialLocation = $scope.location === 'materials' || $scope.location === 'materialsCustomizations'

    const isToShare = (isNotCustomizable || isOnlyDownload) && isTemplate

    return belongsToWideFormat && (isApproved || isToShare) && materialLocation
  }

  $scope.openSendToWideDialog = (template) => {
    getSendToWideDialogController().then(({ SendToWideDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: SendToWideDialogController,
        modalName: 'sendToWideDialog',
        data: {
          artId: template.id
        }
      })

      modal.open()
    })
  }

  function _defineButtonsUser () {
    const buttonsToShowUser = {
      materials: [
        {
          text: $translate.instant('openFileLocation'),
          icon: 'dam',
          click: $scope.openFileLocation,
          show: true,
          divider: false
        }
      ],
      materialsCustomizations: [
        {
          text: $translate.instant('duplicate'),
          icon: 'copy',
          click: $scope.duplicateArt,
          show: api._showDuplicateButton($scope.template),
          divider: false
        },
        {
          text: $scope.template.isArchived ? $translate.instant('unarchive') : $translate.instant('archive'),
          icon: 'archive',
          click: api._archiveUnarchiveAsset,
          show: true,
          divider: false
        }
      ]
    }

    if (buttonsToShowUser[$scope.location]) return buttonsToShowUser[$scope.location]

    return buttonsToShowUser.materials
  }

  function _openRepositoryAssetSettings () {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          assets: [$scope.template]
        },
        onClose: (updatedAsset) => {
          if (!updatedAsset) {
            return
          }

          $scope.template.name = updatedAsset.name
          $rootScope.$emit('preview-header.update-template-name', updatedAsset.name)
        }
      })

      manageAssetsDialog.open()
    })
  }

  function _turnPublicRequestAttachmentAsset () {
    const { id } = $scope.template
    const { isPrivate } = $scope.template
    const message = isPrivate ? 'areYouSureTurnPublic' : 'areYouSureTurnPrivate'

    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant(message),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      closeOnConfirm: true,
      press: () => {
        TasksService.changeIsPrivate(id, !isPrivate)
          .then(() => {
            $scope.template.isPrivate = !$scope.template.isPrivate
            $scope.buttons = api._defineButtons()
            $rootScope.$broadcast('workflow.reloadAttachments')
          })
          .catch(() => {
            ToastService.defaultErrorToast()
          })
      }
    })
  }

  function _deleteRequestAttachmentAsset () {
    const taskId = $scope.contextData.task.id || $scope.contextData.task.taskId

    $scope.onDeleteAsset(taskId, $scope.template)
  }

  function _deleteChecklistAsset () {
    const assetId = $scope.template.assetId

    if (assetId) {
      ToastService.showSuccessToast($translate.instant('deleteChecklistAsset.toast.success'))
      $scope.onDeleteAsset(assetId)
      $rootScope.$emit('onDeleteAsset', { assetId, shouldClose: true })
    }
  }

  $scope.openTemplateSettings = function () {
    api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
      const templatePropertiesDialog = UdsModalService.createModal({
        controller: TemplatePropertiesDialogController,
        modalName: 'templatePropertiesDialog',
        data: {
          art: $scope.template,
          shouldConvertToTemplate: false,
          isEditing: true,
          isCustomizable: $scope.template.isCustomizable,
          artCollectionId: $scope.template.artCollectionId
        },
        onClose: info => {
          $location.search({ ...$state.params, id: null, template: null })

          if (info && info.wasUpdated) {
            api._updateCurrentTemplate()
            $rootScope.$broadcast('reload-arts-page')
          }
        }
      })

      templatePropertiesDialog.open()
    })
  }

  function _updateCurrentTemplate () {
    TemplateService.getTemplateById($scope.template.id).then(template => {
      $scope.template = template
    })
  }

  function _archiveUnarchiveAsset () {
    if ($scope.template.isArchived) {
      if ($scope.template?.isTemplate && $scope.template?.isCustomizable) {
        api._openUnarchiveTemplateDialog($scope.template)
        return
      }

      if ($scope.template.unavailable && !$rootScope.isUserSysAdminAdminDesigner()) {
        api._openUnarchiveArtWarningDialog()
      } else {
        MessageService.warning({
          title: $translate.instant('beware'),
          text: $scope.template.isTemplate
            ? $translate.instant('areYouSureUnarchiveTemplate')
            : $translate.instant('confirmUnarchiveArt'),
          confirmButton: $translate.instant('unarchive'),
          cancelButton: $translate.instant('cancel'),
          closeOnConfirm: true,
          showLoaderOnConfirm: true,
          allowOutsideClick: true,
          press: () => {
            api._unarchiveArt($scope.template)
          }
        })
      }
    } else {
      let message

      if (!$scope.template.isTemplate) {
        message = $translate.instant('areYouSureArchiveArt')
      } else {
        message = $scope.template.isCustomizable ? $translate.instant('archiveTemplateDialogText') : $translate.instant('areYouSureArchiveTemplate')
      }

      const modalConfig = {
        title: $translate.instant('archive'),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
        onConfirm: () => {
          api._archiveArt($scope.template)
        }
      }

      if ($scope.template.campaignId && $scope.template.isTemplate) {
        modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription($scope.template.campaignName)
      } else {
        modalConfig.description = message
      }

      ConfirmationModalService.createModal(modalConfig)
    }
  }

  function _archiveArt (template) {
    ArtsService.archiveArt(template.id)
      .then(() => {
        if (!template.isTemplate) {
          SegmentService.track('archive-art', {
            artId: template.id,
            isUnavailable: template.unavailable
          })
        }
        $rootScope.$broadcast('reload-arts-page', { emitter: 'archiveTemplate', sectionId: template.artCollectionId })
        $timeout(
          () => {
            ToastService.defaultSuccessToast()
          },
          200,
          false
        )
      })
      .catch(ToastService.defaultErrorToast)
  }

  function _unarchiveArt (template) {
    function _unarchiveArtCallback () {
      return ArtsService.unarchiveArt(template.id).then(() => {
        if (template.isTemplate) {
          SegmentService.track('arts-template-archive')
        }
        $rootScope.$broadcast('reload-arts-page')

        $timeout(
          () => {
            ToastService.defaultSuccessToast()
          },
          200,
          false
        )
      })
    }

    if (template.isTemplate) {
      return api._moveTo(template, true).then(changed => {
        if (changed) {
          return _unarchiveArtCallback()
        }
      })
    } else {
      return _unarchiveArtCallback()
    }
  }

  function _openUnarchiveTemplateDialog (template) {
    api.getUnarchiveTemplateDialogController().then(({ unarchiveTemplateController }) => {
      ModalService.showModal({
        templateId: 'unarchiveTemplate.html',
        templateUrl: '/arts/dialogs/unarchive-template/unarchive-template-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: unarchiveTemplateController,
        data: {
          data: {
            template: template
          }
        }
      })
    })
  }

  function _openUnarchiveArtWarningDialog () {
    api.getUnarchiveArtWarningDialogController().then(({ UnarchiveArtWarningDialogController }) => {
      ModalService.showModal({
        templateId: 'unarchiveArtWarning.html',
        templateUrl: '/arts/dialogs/unarchive-art-warning/unarchive-art-warning-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: UnarchiveArtWarningDialogController
      })
    })
  }

  function _moveAssetTo () {
    api._moveTo($scope.template, false)
  }

  function _moveTo (template, skipEventEmit) {
    if ($scope.location === 'materialsCustomizations') {
      return $scope.onMoveAsset(template)
    }

    return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
      return ModalService.showModal({
        templateId: 'moveTemplateCollection.html',
        templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: MoveTemplateCollectionController,
        data: {
          data: template,
          type: 'template'
        }
      }).then(info => {
        if (info && info.changed && !skipEventEmit) {
          ToastService.defaultSuccessToast()
          $rootScope.$broadcast('reload-arts-page', { emitter: 'moveTemplate', ...info })
        }

        return info?.changed
      })
    })
  }

  $scope.copyAssetLink = (template) => {
    NewAssetService.copyAssetUrlToClipboard(template.id)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('copyPostLink.toast.success'))
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('copyPostLink.toast.error'))
      })
  }

  $scope.shouldShowMoreActions = () => {
    const locationsToShowUser = [
      'materials',
      'materialsCustomizations'
    ]

    if (($rootScope.isUser() || $rootScope.isGuest())) {
      if ($scope.location === 'materialsApproval') {
        return api._showShareButton()
      }
      return locationsToShowUser.includes($scope.location)
    }

    const locationsToShow = [
      'materials',
      'brand',
      'materialsCustomizations',
      'materialsApproval',
      'checklist',
      'workflow',
      'repository',
      'repositoryFolder',
      'campaign',
      'campaignAttachment'
    ]
    return locationsToShow.includes($scope.location)
  }

  $scope.uploadNewVersion = (file) => {
    if (!file) {
      return
    }

    if (!$scope.template.s3Key) {
      // show error toast
      ToastService.defaultErrorToast()
      return
    }

    $scope.flags.uploadingNewVersion = true

    UploadService.uploadToS3(file, {
      existentS3Key: $scope.template.s3Key,
      generateThumbnailSync: $scope.template.s3Key.includes('-sync')
    }).then(() => {
      $rootScope.$emit('asset-preview-dialog.reload-preview-details')
      SegmentService.track('file-version-upload')
    }).finally(() => {
      $scope.flags.uploadingNewVersion = false
    })
  }

  $scope.getFileUploadAcceptance = (contentType) => {
    if (contentType?.includes('video')) {
      return 'video/*'
    }

    return contentType
  }

  $scope.showShareUserButton = (isAdmin) => {
    const isApproved = $scope.template.approvalStatus === 'APPROVED'

    const isNotCustomizable = !$scope.template.isCustomizable
    const isOnlyDownload = $scope.template.customizationLevel === 'ONLY_DOWNLOAD'
    const isMaterialLocation = $scope.location && $scope.location !== 'brand' && $scope.location !== 'checklist' && $scope.location !== 'briefing'
    const isTemplate = $scope.isTemplate

    const isToShare = (isNotCustomizable || isOnlyDownload) && isMaterialLocation && isTemplate && !$scope.fromCampaignAction && !$scope.publicCampaign

    return isApproved || isToShare
  }

  $scope.onShareClose = (shared) => {
    const art = $scope.template
    const isTemporarilyAvailable = art?.temporarilyAvailable?.[0]

    if (shared && isTemporarilyAvailable) {
      ArtsService.updateTemporarilyAvailableArt(art.id, { shared: true })
    }
  }

  function _openBindCampaignDialog () {
    $scope.openBindCampaignDialog()
  }

  $scope.openBindCampaignDialog = function () {
    const onClose = (bindDetails) => {
      if (bindDetails) {
        api._unbindAssetFromCampaign(bindDetails)
      }
    }

    CampaignService.openUnbindCampaignDialog($scope.template, 'arts', onClose)
  }

  function _unbindAssetFromCampaign (bindDetails) {
    if ($scope.template.isTemplate) {
      ArtsService.unbindTemplateFromCampaign(bindDetails)
        .then(() => {
          ToastService.defaultSuccessToast()
          $rootScope.$broadcast('reload-arts-page')
          $scope.closePreview()
        })
        .catch(() => {
          ToastService.defaultErrorToast()
        })
    } else {
      AssetService.unbindAssetFromCampaign(bindDetails)
        .then(() => {
          ToastService.defaultSuccessToast()
          $scope.closePreview()
        })
        .catch(() => {
          ToastService.defaultErrorToast()
        })
    }
  }

  function _openRemoveAttachmentDialog () {
    getRemoveAttachmentDialogController().then(({ RemoveAttachmentController }) => {
      const removeAttachmentDialog = UdsModalService.createModal({
        controller: RemoveAttachmentController,
        modalName: 'removeAttachmentDialog',
        data: {
          currentModule: 'campaign',
          assetId: $scope.template.id,
          campaignId: $scope.template.campaignId
        },
        onClose: (removeDetails) => {
          if (removeDetails) {
            api._removeAttachmentFromCampaign(removeDetails, $scope.template.campaignId)
          }
        }
      })

      removeAttachmentDialog.open()
    })
  }

  function _removeAttachmentFromCampaign (assetId, campaignId) {
    CampaignService.removeAttachmentFromCampaign({ assetId, campaignId })
      .then(() => {
        $rootScope.$emit('campaign.reload-assets')
        $scope.closePreview()
        ToastService.defaultSuccessToast()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  $scope.showWorkflowShareButton = () => {
    const isWorkflowClient = $scope.flags.isWorkflow
    const isFilesModule = $scope.location === 'repository'

    return isWorkflowClient && isFilesModule
  }

  $scope.openShareDialog = (template) => {
    api.getShareWithGuestsDialogController().then(({ ShareWithGuestsDialogController }) => {
      const shareWithGuestsDialog = UdsModalService.createModal({
        controller: ShareWithGuestsDialogController,
        modalName: 'shareWithGuestsDialog',
        data: {
          itemType: 'assetPack',
          assetPack: [{
            id: template.id,
            type: 'asset'
          }],
          packTitle: template.name
        }
      })
      shareWithGuestsDialog.open()
    })
  }
}

export { AssetPreviewHeaderController }
